<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-sm-12 list-container nopads my-1">
        <div class="data-list-item add pointer" @click.stop="$emit('add')">
            <div class="item-img-cont add-title">
                <i class="fa fa-plus" />
            </div>
            <div class="item-text-cont">
                <span class="item-title-add">{{ $t('area_report.new_report') }}</span>
                <font-awesome-icon icon="file-invoice" class="card-body-icon"/>
            </div>
        </div>
        <Transition name="fade">
            <div v-if="resultList && resultList.length > 0" id="accordion" class="col-sm-12 list-content result-table">
                <vue3-datatable
                    ref="resultTable"
                    :rows="resultList"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :sortable="true"
                    :height="results.length > 8 ? '55vh' : '100%'"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="emitDetails"
                >
                    <template #completed_time="row">
                        {{ row.value && row.value.completed_time ? toLocalTime(row.value.completed_time) : '' }}
                    </template>
                </vue3-datatable>
            </div>
        </transition>
    </div>
</template>

<script>
import {areaReportHelper} from '../../mixins/AreaReportMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'AreaReportList',
    components: {Vue3Datatable},
    mixins: [areaReportHelper, timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'completed_time',
            sortDesc: true,
            fields: [
                {field: 'area.name', title: this.$t('area_report.area_name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'completed_time', title: this.$t('area_report.completed'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('area_report.status'), sort: true, headerClass: 'routa-table-header'}
            ],
            resultList: []
        }
    },
    watch: {
        results() {
            this.resultList = []
            let temp = []
            this.results.forEach(item => {
                let newItem = item
                newItem.status = item.status === 1 ? this.$t('area_report.status_open') : this.$t('area_report.completed')
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.resultList = temp
            })
        }
    },
    mounted() {
        this.resultList = this.results
    },
    methods: {
        emitDetails: function (details) {
            this.$emit('details', details)
        }
    }
}
</script>
